import React, { useState } from 'react'
import './ViewCallDetailsStyle.css'
// import CallRecordpopup from '../../CallRecordpopup/CallRecordpopup'
import Progressbar from '../../ProgressBar/Progressbar';
import { useNavigate } from 'react-router-dom';
import Button from '../../Button/Button';
import moment from 'moment/moment';

const ViewCallDetails = ({ isActive, setIsActive, menteeFeedback, mentorFeedback, callInfo, handleClose }) => {

    const navigate = useNavigate();
    const [fbackopen, setfbackopen] = useState(1);

    return (
        <div className={`popupWrapper poupviewtab ${isActive && "active"}`}>
            <div className={`popupContainer poupCDcontainer`}>
                <div className="popupBody DscallAdbody">
                    <span className="closebtn mb10">
                        <img src="/assets/svg/close.svg" alt="" onClick={handleClose} />
                    </span>
                    <div className="headingpoup">
                        <h3>View Call Details</h3>
                    </div>

                    <div className=" Adwrapperdetails">
                        <div className="HeaderCallDetailsFaq">
                            <p className='text2'>
                                Agenda:
                                <span className='boldtext ml4'>{callInfo?.agenda ? callInfo?.agenda : "---"}</span>
                            </p>
                        </div>
                        <div className='AgendapopupCallhistory'>
                            <div className='AnswerFaq  AnsForNewFaqUsers'>
                                <div className="answerFaqnew">
                                    <ul>
                                        <li>
                                            <div className="profileHistoryDeatils f-items-center">
                                                <div className='userpopupimg'>
                                                    <img src={callInfo?.mentor?.profileImg ? callInfo?.mentor?.profileImg : "/assets/img/User.png"} alt="" className='pointer' />
                                                </div>
                                                <div className="CallDetailsNameData flex">
                                                    <div className="NameDetails">
                                                        <h3 className='namelink pointer' onClick={() => { navigate(`/admin/mentor-profile/${callInfo?.mentor?.id}`) }}>{callInfo?.mentor?.firstName ? `${callInfo?.mentor?.firstName} ${callInfo?.mentor?.lastName}` : "---"}</h3>
                                                        <p className="text2 capitilize">{callInfo?.mentor?.profession?.designation ? callInfo?.mentor?.profession?.designation : "---"}</p>
                                                    </div>
                                                    <span className='Mentorspan Designspan'>Mentor</span>
                                                </div>
                                            </div>
                                        </li>
                                        {callInfo?.meetingStatus === "completed" && <>
                                            <li> <span>Date: </span>{callInfo?.startTime ? moment(callInfo?.startTime).utcOffset("-00:00").format("DD MMMM, YYYY") : "---"}</li>
                                            <li> <span>Call Start time: </span>{callInfo?.startedAt ? moment(callInfo?.startedAt).format("hh:mm a") : "---"}</li>
                                            <li> <span>Call started by: </span>{callInfo?.startedBy ? callInfo?.startedBy : "---"}</li>
                                        </>}
                                        {(callInfo?.meetingStatus === "cancelled" || callInfo?.meetingStatus === "rescheduled") &&
                                            <li><span>Reason: </span>{callInfo?.cancelReason}</li>
                                        }
                                        {callInfo?.meetingStatus === "pending" &&
                                            <li><span className='capitilize'>Mentor: </span>{callInfo?.isMentorJoined ? "Joined" : "No Show"}</li>
                                        }
                                        <li className='flex'> <span>Status:</span>
                                            <p className={`conptext ${callInfo?.meetingStatus === "pending" ? 'noshow' : callInfo?.meetingStatus?.toLowerCase()} ml4 capitilize`}>{callInfo?.meetingStatus ? callInfo?.meetingStatus === "pending" ? "No Show" : callInfo?.meetingStatus : "---"}</p>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>
                                            <div className="profileHistoryDeatils f-items-center">
                                                <div className="userpopupimg">
                                                    <img src={callInfo?.mentee?.profileImg ? callInfo?.mentee?.profileImg : "/assets/img/User.png"} alt='' />
                                                </div>
                                                <div className="CallDetailsNameData flex">
                                                    <div className="NameDetails">
                                                        <h3 className='namelink pointer' onClick={() => { navigate(`/admin/mentee-profile/${callInfo?.mentee?.id}`) }}>{callInfo?.mentee?.firstName ? `${callInfo?.mentee?.firstName} ${callInfo?.mentee?.lastName}` : "---"}</h3>
                                                        <p className="text2 capitilize">{callInfo?.mentee?.profession?.title ? callInfo?.mentee?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"}</p>
                                                    </div>
                                                    <span className='Menteespan Designspan'>Mentee</span>
                                                </div>
                                            </div>
                                        </li>
                                        {callInfo?.meetingStatus === "completed" && <>
                                            <li> <span>Call Duration: </span>{callInfo?.callDuration ? (callInfo?.callDuration / 60).toFixed(0) + " min" : "---"}</li>
                                            <li> <span>Call End time: </span>{callInfo?.endedAt ? moment(callInfo?.endedAt).format("hh:mm a") : "---"}</li>
                                            <li> <span>Call Ended by: </span>{callInfo?.endedBy ? callInfo?.endedBy : "---"}</li>
                                        </>}
                                        {(callInfo?.meetingStatus === "cancelled" || callInfo?.meetingStatus === "rescheduled") &&
                                            <li><span className='capitilize'>{callInfo?.meetingStatus} by: </span>{callInfo?.cancelledBy ? callInfo?.cancelledBy : "---"}</li>

                                        }
                                        {callInfo?.meetingStatus === "pending" &&
                                            <li><span className='capitilize'>Mentee: </span>{callInfo?.isMenteeJoined ? "Joined" : "No Show"}</li>
                                        }
                                    </ul>

                                </div>


                                {(callInfo?.meetingStatus === "completed" || callInfo?.meetingStatus === "pending") && <>
                                    <div className="dottedbr mb-20"></div>
                                    <div className="headercontentfaq flex-between ">
                                        <div className="btnRightsidesale pillButtons">
                                            <Button name={'For Mentee'} className={fbackopen === 1 && 'active'} onClick={() => setfbackopen(1)} />
                                            <Button name={'For Mentor'} className={fbackopen === 2 && 'active'} onClick={() => setfbackopen(2)} />
                                        </div>
                                    </div>
                                    {fbackopen === 1 &&
                                        <div className={`Fbackactivetab mt-30 ${fbackopen === 1 && 'active'}`}>
                                            {mentorFeedback && Object?.keys(mentorFeedback).length > 0 ? <div className={`ProgressQuestionCallhistory`}>
                                                <div className="QuestionProgressbarPop">
                                                    <h3>How was your experience with the Mentee?</h3>
                                                    <Progressbar count={mentorFeedback?.answer1 ?? 0} />
                                                </div>

                                                <div className="QuestionProgressbarPop">
                                                    <h3>What was the mentee’s problem about?</h3>
                                                    <p className="text2 capitilize">{mentorFeedback?.answer2 ? mentorFeedback?.answer2 : "---"}</p>
                                                </div>
                                                <div className="QuestionProgressbarPop">
                                                    <h3>Were you able to come up with an action plan for the mentee?</h3>
                                                    <p className="text2 capitilize">{mentorFeedback?.answer3 ? mentorFeedback?.answer3 : "---"}</p>
                                                </div>
                                                <div className="QuestionProgressbarPop">
                                                    <h3>How would you rate the mentee’s employability, if you were to hire them for your own team?</h3>
                                                    <Progressbar count={mentorFeedback?.answer4 ?? 0} />
                                                </div>
                                            </div> : "No Feedback Given"}
                                        </div>}

                                    {fbackopen === 2 && <div className={`Fbackactivetab mt-30 ${fbackopen === 2 && 'active'}`}>
                                        {menteeFeedback && Object?.keys(menteeFeedback).length > 0 ? <div className={`ProgressQuestionCallhistory`}>
                                            <div className="QuestionProgressbarPop">
                                                <h3>Was the call helpful for you ?</h3>
                                                <p className="text2 capitilize">{menteeFeedback?.answer1 ? menteeFeedback?.answer1 : "---"}</p>
                                            </div>

                                            <div className="QuestionProgressbarPop">
                                                <h3>Would you like to schedule a call again with the same Mentor?</h3>
                                                <p className="text2 capitilize">{menteeFeedback?.answer2 ? menteeFeedback?.answer2 : "---"}</p>
                                            </div>
                                            <div className="QuestionProgressbarPop">
                                                <h3>Was the Mentor able to answer your questions?</h3>
                                                <p className="text2 capitilize">{menteeFeedback?.answer3 ? menteeFeedback?.answer3 : "---"}</p>
                                            </div>
                                            <div className="QuestionProgressbarPop">
                                                <h3>Rate your experience with the Mentor?</h3>
                                                <Progressbar count={menteeFeedback?.answer4 ?? 0} />
                                            </div>
                                        </div> : "No Feedback Given"}
                                    </div>}
                                </>}
                            </div>

                        </div>

                        {callInfo?.mentorshipQuestions &&
                            <>
                                <div className="dottedbr mb-20"></div>

                                <div className={`Fbackactivetab mt-20 p-20`}>
                                    <h3 className='text18'>Questions!</h3>
                                    <div className={`ProgressQuestionCallhistory`}>
                                        <div className="QuestionProgressbarPop">
                                            <h3>What are your desired outcomes from this Mentorship Call?</h3>
                                            <p className="text2 capitilize">{callInfo?.mentorshipQuestions?.outcome ? callInfo?.mentorshipQuestions?.outcome : "---"}</p>
                                        </div>
                                        <div className="QuestionProgressbarPop">
                                            <h3>How do you think this Mentorship Call can help you?</h3>
                                            <p className="text2 capitilize">{callInfo?.mentorshipQuestions?.help ? callInfo?.mentorshipQuestions?.help : "---"}</p>
                                        </div>
                                    </div>
                                </div>
                            </>}

                    </div>

                </div>
            </div>
        </div>
    )
}

export default ViewCallDetails